import React, { useState } from "react";
import { Button } from "@picklebet/ui";
import { attempt } from "utilities/attempt";
import * as styles from "./PayIdCopyField.module.scss";

type PayIdCopyFieldProps = {
  value: string;
  label?: string;
};

const COPIED_RESET_MS = 3000;

export const PayIdCopyField = ({
  value,
  label = "PayID Email",
}: PayIdCopyFieldProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    const result = await attempt(navigator.clipboard.writeText(value));

    if (result.ok) {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), COPIED_RESET_MS);
    } else {
      // Clipboard access can be blocked (insecure context / denied permission);
      // leave the field untouched so the user can still select the value manually.
    }
  };

  return (
    <div className={styles.field}>
      <span className={styles.label}>{label}</span>

      <div className={styles.frame}>
        <span className={styles.value} data-testid="payid-copy-value">
          {value}
        </span>

        <Button
          size="sm"
          variant="primary"
          className={styles.copyButton}
          onClick={handleCopy}
        >
          {isCopied ? "Copied!" : "Copy"}
        </Button>
      </div>
    </div>
  );
};
